import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import { Link } from 'react-router-dom'
import { camelCaseToDashed } from 'utils/camelCaseConverter'
import { contentTypesNames } from 'interfaces/contentTypeInterface'
import { ArrowIcon } from 'assets/icons'
import { Button } from 'components/atoms'
import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

const ContentTypesButtons = ({ item }) => {
  const { brand } = useTheme()
  return (
    <Link to={`/${item?.replace('_', '-')}`} key={item}>
      <Button
        label={contentTypesNames(camelCaseToDashed(item))}
        classBtn={'icon'}
        icon={ArrowIcon}
        fontSize='26px'
        fontWeight={BRAND.ATH === brand ? '600' : '650'}
        iconWidth='17.49px'
        iconHeight='26.72px'
        iconColor={BRAND.ATH === brand ? theme.colors.lightGold : theme.colors.white}
      />
    </Link>
  )
}

ContentTypesButtons.defaultProps = {}

ContentTypesButtons.propTypes = {
  item: PropTypes.string,
}

export default ContentTypesButtons
